// Product Gate Price

document.addEventListener('DOMContentLoaded', () => {

    var productPrice = document.querySelector('.price__container .price__regular .price-item');
    var productButtons = document.querySelector('.product-form__buttons');

    if ( productPrice && productButtons ) {

        const newPriceElement = document.createElement('div');
        newPriceElement.innerHTML = `
            <h3>Total (inc VAT)</h3>
            <p>${productPrice.textContent}</p>
        `;
        //newPriceElement.textContent = productPrice.textContent;
        newPriceElement.classList.add('price-total');

        productButtons.before(newPriceElement);

        // Select the target node.
        var targetPriceChange = productPrice;
        // Create an observer instance.
        var observerPriceChange = new MutationObserver(function(mutations) {

            newPriceElement.innerHTML = `
                <h3>Total (inc VAT)</h3>
                <p>${productPrice.textContent}</p>
            `;
            
        });
        // Pass in the target node, as well as the observer options.
        observerPriceChange.observe(targetPriceChange, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });

    }

});